import { Globe } from 'lucide-react'
import { locale, otherLocale, setLocale } from '../lib/i18n'
import './LanguageSwitch.css'

/**
 * The language control the legacy layout carries as a dropdown (اللغة) in both
 * panels.
 *
 * There are exactly two languages, so a dropdown is one interaction too many:
 * this is a single button that names the language you would GET, in that
 * language's own script. Pressing it is the whole gesture.
 *
 * `tone="dark"` is the variant for surfaces that are already painted in the
 * brand — the learner's header and the auth screens' panel.
 *
 * THE GLOBE, not the `Languages` glyph. That one is the A-over-文 translate
 * mark, and translate is a different promise: it says the CONTENT in front of
 * you will be rendered into another language. This button does not touch
 * content — it changes which language the interface is in, which is a locale
 * choice, and a globe is what a locale choice looks like everywhere. It is also
 * what the auth screen's own language button has always used (AuthHead.jsx), so
 * the two controls that do the same thing now look the same.
 */
export default function LanguageSwitch({ tone = 'light', compact = false }) {
  return (
    <button
      type="button"
      className={`langswitch langswitch--${tone}${compact ? ' langswitch--compact' : ''}`}
      onClick={() => setLocale(otherLocale.code)}
      /* NO TOOLTIP. This button carries its label in the open — `English`, or the
         two-letter form when the bar is narrow — so a bubble repeating it is noise.
         Announced in the language being offered, so a screen reader in either
         language says something meaningful. */
      lang={otherLocale.code}
      aria-label={otherLocale.label}
    >
      <Globe size={16} strokeWidth={1.75} aria-hidden="true" />
      <span
        className="langswitch__label"
        lang={otherLocale.code}
        dir={otherLocale.dir}
        /* The two-letter form the narrow rule in the stylesheet swaps in. */
        data-short={otherLocale.short}
      >
        {compact ? otherLocale.short : otherLocale.label}
      </span>
      <span className="sr-only">{locale.label}</span>
    </button>
  )
}
